import {Component, OnInit} from '@angular/core';
import {NgForm} from '@angular/forms';
import {SubmitApplicationService} from '../core/services/submit-application.service';
import {HttpErrorResponse} from '@angular/common/http';
import {ToastrService} from 'ngx-toastr';
import * as countries from '../../assets/countries.json';
import {environment} from '../../environments/environment';

import {Globals} from '../globals';

@Component({
  selector: 'app-application-form',
  templateUrl: './application-form.component.html',
  styleUrls: ['./application-form.component.scss']
})

export class ApplicationFormComponent implements OnInit {
  itsMexico = false;
  countryData;
  programData;
  phoneNumberPattern = '^\\(?[\\d]{3}\\)?[\\s-]?[\\d]{3}[\\s-]?[\\d]{4}$';
  datePattern = '\\d{1,2}/\\d{1,2}/\\d{4}';
  ssnPattern = '^(?!b(d)1+-(d)1+-(d)1+b)(?!123-45-6789|219-09-9999|078-05-1120)(?!666|000|9d{2})d{3}-(?!00)d{2}-(?!0{4})d{4}$';
  startDateData;
  constructor(private submitApplicationService: SubmitApplicationService,
              private toastr: ToastrService,
              private globals: Globals) {
              this.countryData = (countries as any).default;
              this.programData = environment.programs;
  }

  ngOnInit() {
  }

  onCountryChange(value) {
    this.itsMexico = value.toString() === 'a14o0000001EeyV';
  }

  onProgramChange(value) {
    for (let i = 0; i < this.programData.length; i++) {
      if (value === this.programData[i].id) {
        this.startDateData = this.programData[i].startDates;
      }
    }
    (<HTMLSelectElement>document.getElementById('programStartDate')).selectedIndex = 0;
  }

  public onSubmit(data: NgForm) {
    document.getElementById('submit').setAttribute('disabled', 'true');
    const info = data.value;
    const appJson = {
      'opp': {
        'Area_of_Interest__c': '',
        'Program_of_Interest__c': info.programName,
        'Selected_Program_Start_Date__c': info.programStartDate
      },
      'bp': {
        'SSN__c': info.ssn,
        'First_Name__c': info.firstName,
        'Last_Name__c': info.lastName + ' ' + info.secondLastName,
        'Middle_Name__c': info.middleName,
        'Shipping_Street__c': info.addressLine1,
        'Shipping_Street2__c': info.addressLine2,
        'Shipping_City__c': info.city,
        'Shipping_State_Text__c': info.state,
        'Shipping_Postal_Code__c': info.zip,
        'Shipping_Country__c': info.country,
        'Home_Phone__c': info.homePhone.replace('-', '').replace('(', '').replace(')', '').replace(' ', ''),
        'Mobile_Phone__c': info.cellPhone,
        'Birthdate__c': info.dateOfBirth.slice(6) + '-' + info.dateOfBirth.slice(3, 5) + '-' + info.dateOfBirth.slice(0, 2),
        'Personal_Email__c': info.personalEmail,
        'Alternate_Email__c': '',
        'Gender__c': info.gender,
        'Race__c': info.race,
        'Country_Of_Citizenship__c': info.citizenship,
        'Billing_Street__c': 'Av. Parque Chapultepec No. 56 Piso 1',
        'Billing_Street2__c': 'Colonia El Parque',
        'Billing_City__c': 'Naucalpan',
        'Billing_State_Text__c': 'Mexico',
        'Billing_Postal_Code__c': '53398',
        'Billing_Country__c': 'a14o0000001EeyV',
        'Military_Veteran__c': '',
        'Active_US_Military__c': '',
        'Has_Studied__c': '',
        'UVM_Laureate_ID__c': info.laureateID
      },
      'con': {
        'firstName': info.firstName,
        'LastName': info.lastName + ' ' + info.secondLastName,
        'UVM_Campus__c': info.uvmCampus.slice(0, 3),
        'UVM_Campus_Description__c': info.uvmCampus
      }
    };

    this.submitApplication(appJson);

  }

  private submitApplication(data: Object) {
    this.toastr.info('Your application is being submitted.', 'Submitting...', {
      timeOut: 20000
    });
    console.log('submitting application...');
    this.submitApplicationService.submitApplication(data).subscribe(() => {
        this.toastr.clear();
        this.toastr.success('Application submitted successfully', 'Success!');
        document.getElementById('submit').removeAttribute('disabled');
        this.globals.isCreateApplication = false;
      }, (error: HttpErrorResponse) => {
        console.log(error);
        document.getElementById('submit').removeAttribute('disabled');
        this.toastr.clear();
        this.toastr.error(error['_body'], 'Error!');
      }
    );
  }

}
